import { UnitTaskModalButton } from '@apps-common/apps/portal/pages/units/components'
import { ManagementUnitsFilterButton } from '@apps-common/apps/portal/pages/units/components/management/ManagementUnitsFilterButton'
import { UnitAccountNoModalButton } from '@apps-common/apps/portal/pages/units/components/UnitAccountNoModalButton'
import { UnitAddOptionsModal } from '@apps-common/apps/portal/pages/units/modals'
import { NavbarCompanyLogo } from '@apps-common/components/common/logos'
import { PageTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundSm } from '@apps-common/components/elements/button'
import { Header, VertSpacerLg, VertSpacerMd, VertSpacerSm } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { UNIT_STATUS_ACTIVE } from '@apps-common/config/unit-filter'
import { snakeToSentence } from '@apps-common/helpers/snakeCaseToSentence'
import { IAppNavigationOptions } from '@apps-common/hooks/useNavigation'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { useManagementUnitsFilterStore } from '@apps-common/stores'
import {
  ROUTE_CREATE_MULTIPLE_UNIT,
  ROUTE_CREATE_UNIT,
  ROUTE_UNIT_ACTIVATIONS,
  ROUTE_UNITS
} from '@apps-radionet-portal/config/private-routes'

interface IProps {
  icons?: any[]
  rightComponent?: any
  leftComponent?: any
  loading: boolean
  navigateForward: (opts: IAppNavigationOptions) => void
  searchCount: number
}

export const ManagementUnitsHeader: React.FC<IProps> = ({
  icons,
  rightComponent,
  leftComponent,
  loading,
  navigateForward,
  searchCount
}) => {
  const managementFilterState = useManagementUnitsFilterStore()

  return (
    <Header classes='!max-w-[1650px]'>
      <Navbar transparent startComponents={<NavbarCompanyLogo />} icons={icons} />
      <Breadcrumbs route={ROUTE_UNITS} />
      <div className='flex items-start justify-between'>
        <PageTitle classes='flex items-start gap-[10px] capitalize'>
          Devices
          <span className='hidden md:inline-block text-[0.6em] jost-medium'>({snakeToSentence(managementFilterState.status)})</span>
        </PageTitle>
        <div className='flex items-center gap-[8px]'>
          <ModalButton
            component={UnitAddOptionsModal}
            disabled={false}
            classes=''
            componentProps={{}}
            enterAnimation={modalSlideUpEnterAnimation}
            leaveAnimation={modalSlideUpLeaveAnimation}
            confirmCallbackAfterDismiss={(data: string) => {
              if (data === 'create-single') {
                navigateForward({
                  routeUrl: ROUTE_CREATE_UNIT.buildPath(),
                  route: ROUTE_CREATE_UNIT
                })
              } else if (data === 'create-multiple') {
                navigateForward({
                  routeUrl: ROUTE_CREATE_MULTIPLE_UNIT.buildPath(),
                  route: ROUTE_CREATE_MULTIPLE_UNIT
                })
              }
            }}
          >
            <ButtonRoundSm type='div' size='lg' className='action-success' tooltip={{ id: `devices-add-options-tooltip`, message: 'Add' }}>
              <commonIcons.add />
            </ButtonRoundSm>
          </ModalButton>
          <UnitAccountNoModalButton />
          {managementFilterState.status === UNIT_STATUS_ACTIVE.value && (
            <UnitTaskModalButton
              searchParams={managementFilterState.getSearchParams()}
              searchCount={searchCount}
              navigateForward={navigateForward}
            />
          )}
          <ButtonRoundSm
            type='button'
            size='lg'
            className='action-success'
            tooltip={{ id: `devices-activations-tooltip`, message: 'Activations' }}
            callback={() =>
              navigateForward({
                routeUrl: ROUTE_UNIT_ACTIVATIONS.buildPath(),
                route: ROUTE_UNIT_ACTIVATIONS
              })
            }
          >
            <commonIcons.srActivations />
          </ButtonRoundSm>
          <ManagementUnitsFilterButton />
        </div>
      </div>
      <VertSpacerMd className='hidden md:block' />
      <VertSpacerLg className='block md:hidden' />
      <div className='flex items-center justify-between gap-[5px] sm:px-[5px] sm:pt-0'>
        {leftComponent}
        {rightComponent}
      </div>
      {(rightComponent || leftComponent) && <VertSpacerSm />}
    </Header>
  )
}
